import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import ImageText3 from "../components/ImageText3";
import RichText from "../components/RichText";

import video from "../assets/videos/noxsolutions.mp4";
import imageurl1 from "../assets/images/nox1.png";
import imageurl2 from "../assets/images/nox2.png";
import video2 from "../assets/videos/service2.mp4";

function NOxSolutions() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Delambdasondeis eensensor die het zuurstofgehalte meet in de
        uitlaatgassen. Deze waarden worden gebruikt om deverhouding tussen
        brandstof en lucht te meten en samen te stellen (brandstofverhouding).
        Hoe schoner de verbranding, hoe schoner de lucht blijft en hoe beter de
        brandstofverhouding is, hoe minder brandstof de auto verbruikt.De
        functie van de lambdasonde is met name voor een schone verbranding endat
        er zominmogelijk schadelijke uitlaatgassen worden uitgestoten. Bij een
        kapotte lambdasonde kan het zijn dat de auto meerbrandstof gaat
        verbruiken en op den duur ook de katalysator stuk gaat.
      </p>
      <br />
      <p className="text-white text-lg">
        Het kan voorkomen dat bij het monteren van sportcats of de catpijpen in
        uw uitlaatsysteem uw motorlamp in het dashboard gaat branden. Bij het
        uitlezen van de auto zullen de volgende foutcodes tevoorschijn komen:
        P0420 en P0430 Cat Efficiency.
      </p>
    </>
  );

  const text2 = (
    <>
      <p className="text-white text-lg">
        Een NOxsensormeetdestikstofoxide waarden die nog in de uitlaatgassen
        aanwezig kunnen zijn. Deze milieuonvriendelijke stoffen ontstaan doordat
        er veel zuurstof in de motor verbrandt.
      </p>
      <br />
      <p className="text-white text-lg">
        Om deze stoffen onschadelijk te maken is de AdBlue geïntroduceerd. Aan
        de hand van het inspuiten van AdBlue worden de NOx waarden
        opgeneutraliseerd. Ook door de directe brandstofinspuiting en een arm
        brandstofmengsel veroorzaakt verhoogde NOx waarden wat met deze AdBlue
        verminderd wordt.
      </p>
      <br />
      <p className="text-white text-lg">
        Hoe hoger de NOx waarden, des te meer Adblue er ingespoten wordt om de
        gassen te neutraliseren. Indien de NOx waarde te hoog is zal de auto
        gaan regenereren net als met een roetfilter. Hier zal de motor met een
        hogere toeren draaien en brandstofmengsel inspuiten in combinatie met
        een hogere temperatuur in uw uitlaatsysteem. Dit zorgt ervoor dat alle
        overige resten verbranden tot de stoffen weer milieuvriendelijk zijn.
      </p>
      <br />
      <p className="text-white text-lg">
        Bij X-TREMETUNINGS bieden wij de service om de Lambdasonde of
        NOxtedeactiveren. Hierbij worden de controles uit de ECU* geschreven.
      </p>
      <p className="text-white text-lg font-semibold">
        *Cat efficiency, foutcodes P0420 en P0430
      </p>
      <p className="text-white text-lg font-semibold">
        *ECU, Electronic Control Unit
      </p>
    </>
  );

  const text4 = (
    <>
      <h3 className="text-[#BD0E0E] text-xl">LET OP!</h3>
      <br />
      <p className="text-white text-lg">
        Deze service is wegens de strenge milieunormen niet toegestaan op de
        openbare weg en is geheel op eigen risico van de klant
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="LAMBDASONDE & NOx SOLUTIONS" />
      <RichText heading="Deze sensoren zijn te vinden in de uitlaat van de auto bij zowel benzine- als dieselmotoren." />
      <ImageText2
        heading="Lambda/ lambdasonde"
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText3
        heading="NOx"
        text={text2}
        imageUrl={imageurl2}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <RichText text={text4} />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default NOxSolutions;
